/**
 * 적립금 표시 설정 - ProductList와 ProductDetail에서 공통으로 사용
 */
export const RewardPointProperties = {
  group: '적립금 설정',
  properties: [
    {
      name: 'componentProps.showRewardPoints',
      label: '적립금 표시',
      control: 'Checkbox',
      defaultValue: false,
      helpText: '적립금을 표시합니다'
    },
    {
      name: 'componentProps.rewardPointBase',
      label: '적립 기준',
      control: 'Select',
      options: [
        { value: 'pv', label: 'PV 기준' },
        { value: 'price', label: '판매가 기준' }
      ],
      defaultValue: 'pv',
      dependency: {
        field: 'componentProps.showRewardPoints',
        value: true
      }
    },
    {
      name: 'componentProps.rewardPointPercentage',
      label: '적립 비율 (%)',
      control: 'NumberField',
      min: 0,
      max: 100,
      step: 0.1,
      defaultValue: 1,
      helpText: '적립 기준 금액의 퍼센티지로 적립금을 계산합니다',
      dependency: {
        field: 'componentProps.showRewardPoints',
        value: true
      }
    },
    {
      name: 'componentProps.rewardPointLabel',
      label: '적립금 라벨',
      control: 'TextField',
      defaultValue: '적립금',
      dependency: {
        field: 'componentProps.showRewardPoints',
        value: true
      }
    },
    {
      name: 'componentProps.rewardPointFormat',
      label: '표시 형식',
      control: 'Select',
      options: [
        { value: 'amount', label: '금액만 표시 (예: 1,000원)' },
        { value: 'percentage', label: '퍼센트만 표시 (예: 1%)' },
        { value: 'both', label: '금액과 퍼센트 모두 표시 (예: 1,000원 (1%))' }
      ],
      defaultValue: 'amount',
      dependency: {
        field: 'componentProps.showRewardPoints',
        value: true
      }
    }
  ]
};